class Accordion extends HTMLElement {
  constructor() {
    super();

    let _triggers = this.querySelectorAll('.accordion-item__triger');

    if(_triggers.length > 0){
      _triggers.forEach((t)=>{
        t.addEventListener('click',(e)=>{
          if(e.target.nextElementSibling.classList.contains('current')){
            e.target.nextElementSibling.classList.remove('current');
          } else {
            this.doAccordion(e);
          }
        })
      })
    }
  }

  closeAllOpen(){
    try {
      this.querySelectorAll('.accordion-item__content').forEach((a)=>{
        a.classList.remove('current');
      }) 
    } catch (err) {
      console.error(err);
    }
  }

  doAccordion(e){
    this.closeAllOpen();
    let _content = e.target.nextElementSibling
    _content.classList.toggle('current');
  }
}


customElements.define('reusable-accordion', Accordion);
